import { RepositoryMain } from "../Domain/RepositoryMain";
import { IServiceSobregiroPendienteRequest } from "../Domain/service/IServiceSobregiroPendiente";

export class UseCaseSobregiroPendientes {
    private repository: RepositoryMain;

    constructor(_repository: RepositoryMain) {
        this.repository = _repository;
    }

    public async exec(payload: IServiceSobregiroPendienteRequest) {
        return await this.repository.getSobreGiroPendientes(payload);
    }
}
